import { render, staticRenderFns } from "./title-bar.vue?vue&type=template&id=6ae7886b&"
import script from "./title-bar.vue?vue&type=script&lang=js&"
export * from "./title-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports